import { PartnerSkills, PartnerStatus } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const partnerValidationMessages = Resources.base.partner.validationMessages;

export const getPartnerGeneralInfoSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z
		.object({
			name: z.string().nullish(),
			middleName: z.string().nullish(),
			surname: z.string().nullish(),
			phone: z.string().nullish(),
			email: z.string().email().nullish(),
			teamSize: z.number().nullish(),
			isCanTrainDay: z.boolean().nullish(),
			marketId: z.number().int(),
			marketRegionId: z.number().int().optional(),
			profileLink: z.string().nullish(),
			notes: z.string().nullish(),
			status: z.nativeEnum(PartnerStatus).nullish(),
			skills: z.array(z.nativeEnum(PartnerSkills)).optional(),
			verticals: z.array(z.coerce.number()),
			serviceAreas: z
				.array(
					z.object({
						marketRegionId: z.number().int(),
						originAddress: z.string().trim().min(1),
						isPrimary: z.boolean(),
						isActive: z.boolean().default(true),
					}),
				)
				.min(1),
		})
		.refine(
			(data) =>
				data.marketRegionId !== undefined && data.marketRegionId !== null,
			{
				message: `${t(partnerValidationMessages.partnerGeneral.marketRegionId)}`,
				path: ["marketRegionId"],
			},
		)
		.refine(
			(data) => data.serviceAreas.filter((area) => area.isPrimary).length === 1,
			{
				message: `${t(partnerValidationMessages.partnerGeneral.serviceAreas)}`,
				path: ["serviceAreas"],
			},
		);
};

export type PartnerGeneralFormModel = z.infer<
	ReturnType<typeof getPartnerGeneralInfoSchema>
>;
